/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type FooterBottomRow_viewer = {
    readonly user?: {
        readonly " $fragmentRefs": FragmentRefs<"CurrencySelector_user">;
    } | null;
    readonly " $fragmentRefs": FragmentRefs<"CurrencySelector_viewer">;
    readonly " $refType": "FooterBottomRow_viewer";
};
export type FooterBottomRow_viewer$data = FooterBottomRow_viewer;
export type FooterBottomRow_viewer$key = {
    readonly " $data"?: FooterBottomRow_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"FooterBottomRow_viewer">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "hasUserId"
    },
    {
      "kind": "RootArgument",
      "name": "userId"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "FooterBottomRow_viewer",
  "selections": [
    {
      "condition": "hasUserId",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "alias": null,
          "args": [
            {
              "kind": "Variable",
              "name": "userId",
              "variableName": "userId"
            }
          ],
          "concreteType": "User",
          "kind": "LinkedField",
          "name": "user",
          "plural": false,
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "CurrencySelector_user"
            }
          ],
          "storageKey": null
        }
      ]
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CurrencySelector_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};
(node as any).hash = 'e2b922f152c8b16822665165dff91495';
export default node;
